import { HTMLChakraProps, forwardRef } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';

import { useActionPreviewContext } from '../ActionPreviewContext';
import { useActionPreviewStyles } from '../useActionPreviewStyles';

export type ActionPreviewFooterProps = HTMLChakraProps<'div'>;

export const ActionPreviewFooter: React.FC<ActionPreviewFooterProps> =
  forwardRef<ActionPreviewFooterProps, 'div'>(({ children, ...props }, ref) => {
    const { footer } = useActionPreviewStyles();
    const { mode } = useActionPreviewContext();

    // Only render footer for pending mode
    if (mode !== 'pending') {
      return null;
    }

    return (
      <chakra.div
        sx={footer}
        className="action-preview-footer"
        {...props}
        ref={ref}
      >
        {children}
      </chakra.div>
    );
  });
ActionPreviewFooter.displayName = 'ActionPreviewFooter';
